<template>
    <div>
        <div class="charity-property-inner border p-3">
            <div class="row px-0 mx-0">
                <div class="col-10 pl-0">
                    <div class="form-check mb-0">
                        <input type="checkbox"
                               :name="group ? group.id : 'check' + _uid"
                               :id="'check' + _uid"
                               :value="property.id"
                               :checked="property.value"
                               @change="onInputValueChanged($event.target.checked)"
                               class="form-check-input"
                               data-testing="order-property-input-checkbox">
                        <label class="form-check-label text-appearance d-flex"
                               :for="'check' + _uid"
                               :class="{ 'text-danger': hasError }"
                               v-tooltip data-toggle="tooltip"
                               :title="charity.title ? charity.title : charity.name">
                            <strong class="text-wrap ml-1" v-html="charity.title ? charity.title : charity.name"></strong>
                        </label>
                        <div class="mt-1 ml-1">
                            <span class="text-wrap" v-html="charityDonationText"></span><br/>
                            <span class="text-primary cursor-pointer d-inline-block mt-1" @click="toggleDescription()">
                                {{ $translate("GonserDT::Template.generalSeeMore") }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-2 align-self-center text-right px-0 px-sm-2">
                    <img class="charity-img img-fluid" :src="'/documents/' + charity.image" :alt="charity.name" />
                </div>
            </div>
        </div>
        <div class="modal fade" id="charityDescription" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title text-primary" id="charityDescriptionTitle" v-html="charity.title ? charity.title : charity.name"></h3>
                        <button type="button" class="close text-primary" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="text-wrap" v-html="charity.shortDescription"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const ApiService = require("../../services/ApiService");
const NotificationService = require("../../services/NotificationService");

import { isNullOrUndefined } from "../../helper/utils";
import { mapState, mapMutations } from "vuex";
import TranslationService from "../../services/TranslationService";

export default {

    name: "charity-order-property-list-item",

    props:
        {
            group: Object,
            property: Object,
            charity: Object
        },

    inject: {
        itemId: {
            default: null
        }
    },

    data()
    {
        return {
            inputValue: "",
            selectedFile: null,
            waiting: false,
            selectionValue: null,
            showDescription: false,
            fsXSellerMargin: 0
        };
    },

    mounted()
    {
        document.addEventListener("onVariationChanged", event =>
        {
            if (event.detail.itemId === this.itemId)
            {
                // clear type specific bindings
                if (this.property.valueType === "selection")
                {
                    this.selectionValue = this.property.value || null;
                }
                else if (this.property.valueType === "file")
                {
                    if (this.property.value && this.property.value.length)
                    {
                        NotificationService.warn(
                            TranslationService.translate("Ceres::Template.singleItemOrderPropertyFileHasReset",
                                { propertyName: this.property.names.name })
                        ).closeAfter(5000);
                    }

                    this.clearSelectedFile();
                }
                else
                {
                    this.inputValue = this.property.value || "";
                }
            }
        });
    },

    computed:
        {
            inputType()
            {
                const orderPropertyGroupingType = this.group ? this.group.orderPropertyGroupingType : null;
                const valueType = this.property.valueType;

                if (valueType === "empty")
                {
                    if (!orderPropertyGroupingType || orderPropertyGroupingType === "none" || orderPropertyGroupingType === "multi")
                    {
                        return "checkbox";
                    }

                    return "radio";
                }

                return valueType;
            },

            selectedFileName()
            {
                if (this.selectedFile)
                {
                    return this.selectedFile.name;
                }

                return "";
            },

            hasError()
            {
                if (this.variationMarkInvalidProperties && this.inputType === "radio")
                {
                    return this.variationMissingProperties.find(property => property.property.id === this.property.id);
                }

                return this.variationMarkInvalidProperties && !this.property.value;
            },

            surcharge()
            {
                return this.property.itemSurcharge || this.property.surcharge;
            },

            selectedDescription()
            {
                if (this.inputType !== "selection" || isNullOrUndefined(this.selectionValue))
                {
                    return null;
                }

                const selectedProperty = this.property.selectionValues[this.selectionValue];

                return selectedProperty.description;
            },

            variationMissingProperties()
            {
                return this.$store.getters[`${this.itemId}/variationMissingProperties`];
            },

            variationMarkInvalidProperties() {
                const currentVariation = this.$store.getters[`${this.itemId}/currentItemVariation`];
                return currentVariation && currentVariation.variationMarkInvalidProperties;
            },

            charityDonationText()
            {
                return TranslationService.translate("GonserDT::Template.itemCharityDonation", {
                    cname: this.charity.name,
                    amount: this.$options.filters.currency(this.surcharge)
                });
            },

            ...mapState({
                isBasketLoading: state => state.basket.isBasketLoading,
            })
        },

    methods:
        {
            onInputValueChanged(value)
            {
                if (this.inputType === "int")
                {
                    value = this.validateInt(value);
                }
                else if (this.inputType === "float")
                {
                    value = this.validateFloat(value);
                }
                else if (this.inputType === "checkbox")
                {
                    if (!value)
                    {
                        value = null;
                    }
                }
                else if (this.inputType === "selection")
                {
                    if (isNullOrUndefined(value) || value.length <= 0)
                    {
                        value = null;
                    }
                }
                else if (this.inputType === "text")
                {
                    if(value === "")
                    {
                        value = null;
                    }
                }

                this.$store.commit(`${this.itemId}/setVariationPropertySurcharges`, this.$store.getters[`${this.itemId}/variationBasePrice`]);
                this.setVariationOrderProperty({ propertyId: this.property.id, value: value });
            },

            validateInt(value)
            {
                value = parseInt(value);

                if (isNaN(value))
                {
                    value = null;
                }

                this.inputValue = value;

                return value;
            },

            validateFloat(value)
            {
                const lastChar = value.slice(-1);

                const str = value.replace(App.decimalSeparator, ".");
                const arr = str.split(".");
                let toFixedLength = 0;

                if (arr.length === 2)
                {
                    toFixedLength = arr[1].length;
                }

                value = parseFloat(str).toFixed(toFixedLength);

                if (isNaN(value))
                {
                    value = null;
                }
                else
                {
                    if (lastChar === "." || lastChar === App.decimalSeparator)
                    {
                        value += lastChar;
                    }

                    value = value.toString().replace(".", App.decimalSeparator);
                }

                this.inputValue = value;

                return value;
            },

            setVariationOrderProperty(orderProperty) {
                return this.$store.commit(`${this.itemId}/setVariationOrderProperty`, orderProperty);
            },

            setPropertyFile(event)
            {
                if (event.target && event.target.files && event.target.files.length > 0)
                {
                    this.selectedFile = event.target.files[0];
                    this.uploadPropertyFile(this.selectedFile);
                }
            },

            uploadPropertyFile(file)
            {
                this.setIsBasketLoading(true);
                this.waiting = true;

                const fileData = new FormData();

                fileData.append("fileData", file);

                ApiService.post("/rest/io/order/property/file", fileData, { processData: false, contentType: false, cache: false, async: true, timeout: 60000, supressNotifications: true })
                    .done(response =>
                    {
                        this.setVariationOrderProperty({ propertyId: this.property.id, value: response });
                    })
                    .fail(error =>
                    {
                        this.clearSelectedFile();
                        this._handleValidationErrors(error);
                    })
                    .always(response =>
                    {
                        this.setIsBasketLoading(false);
                        this.waiting = false;
                    });
            },

            clearSelectedFile()
            {
                this.selectedFile = null;
                this.setVariationOrderProperty({ propertyId: this.property.id, value: null });
                this.$refs.fileInput.value = "";
            },

            _handleValidationErrors(error)
            {
                if (error.hasOwnProperty("validation_errors"))
                {
                    for (const err of Object.values(error.validation_errors))
                    {
                        NotificationService.error(err[0]);
                    }
                }

                if (error.error.message && error.error.message === "Post too large")
                {
                    NotificationService.error(
                        this.$translate("Ceres::Template.errorPostTooLarge" , { maxSize: error.error.maxSize })
                    );
                }
            },

            toggleDescription()
            {
                $('#charityDescription').modal('show');
                // if (!this.showDescription)
                // {
                //     this.showDescription = !this.showDescription;
                //     this.fsXSellerMargin = $(".fs-xseller").css("margin-top");
                //     $(".fs-xseller").css("margin-top", 0);
                // } else {
                //     this.showDescription = !this.showDescription;
                //
                //     setTimeout(() => {
                //         $(".fs-xseller").css("margin-top", this.fsXSellerMargin);
                //     }, 400);
                // }
            },

            ...mapMutations([
                "setIsBasketLoading"
            ]),
        }
}
</script>
